export default __webpack_public_path__ + "static/media/lsp-tuk-2.faed726f.jpg";